module.exports = __webpack_public_path__ + "img/barra_feder_footer.1433f7ec.png";